<div class="mx-20 mt-10 flex justify-between">
  <div class="flex items-center text-3xl text-black">
    <p>
      Welcome back, @if (!isLoading) {
      <b>{{firstName}}!</b>
    }
  </p>
  @if (isLoading) {
    <div class="ml-2 animate-pulse bg-gray-200 w-[150px] h-6 rounded"></div>
  }
</div>
</div>
<div [style]="messageBoxStyle">
  <div class="flex py-8 mt-3 px-3 items-center" id="banner">
    <button aria-label="Decrement Dashboard Message" [disabled]="instructorMessageIter === 0" (click)="decrementMessages()" [ngClass]="instructorMessageIter !== 0? 'flex-shrink justify-self-start text-white h-8 w-8 rounded-full flex justify-center items-center': 'flex-shrink justify-self-start text-transparent h-8 w-8 rounded-full flex justify-center items-center'">
      <fa-icon [icon]="faChevronLeft" />
    </button>
    <div class="flex-grow ml-3 text-lg">
      @if (instructorMessages.length > 0) {
        <div class="sm:max-w-[200px] lg:max-w-[650px] max-h-[150px] line-clamp-2">
          {{instructorMessages[instructorMessageIter].msg}}
        </div>
      }
      @if (instructorMessages.length === 0) {
        <div class="sm:max-w-[200px] lg:max-w-[650px] max-h-[150px] line-clamp-2">
          No announcements!
        </div>
      }
      @if (instructorMessages.length > 1) {
        <div class="flex -mb-5">
          @for (message of instructorMessages; track message; let i = $index) {
            <button aria-label="Dashboard Message" (click)="instructorMessageIter = i" [ngClass]="instructorMessageIter === i? 'rounded-full h-2 w-2 bg-gray-600 mr-1 mt-8': 'rounded-full h-2 w-2 bg-gray-200 mr-1 mt-8'">
            </button>
          }
        </div>
      }
    </div>
    @if (instructorMessageIter !== instructorMessages.length-1 && instructorMessages.length !== 0) {
      <button aria-label="Increment Dashboard Message" (click)="incrementMessages()" class="flex-shrink justify-self-end text-black h-8 w-8 rounded-full flex justify-center items-center hover:bg-gray-200">
        <fa-icon [icon]="faChevronRight" />
      </button>
    }
  </div>
</div>
<div class="mx-20 mt-10">
  @if (showAllUsers) {
    <button (click)="allUsersClick()" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center float-left text-sm font-medium" id="allusers">
      All Users
    </button>
  }
  @if (showAllUsers) {
    <button (click)="addNewUser()" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center text-sm font-medium float-left" id="createuser">
      Create a New User
    </button>
  }
  @if (showAllUsers) {
    <button (click)="importUsers()" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center text-sm font-medium float-left" id="importusers">
      Import User List
    </button>
  }
  @if (roleCreate) {
    <button (click)="userRolesClick()" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center text-sm font-medium float-left" id="userroles">
      User Roles
    </button>
  }
  @if (examCreate) {
    <button (click)="createExamClick()" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center text-sm font-medium float-left" id="createnewexam">
      Create New Exam
    </button>
  }
</div>
